import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const AboutPage = () => (
  <div className="min-h-screen bg-[#040c0e] text-cyan-100 px-6 py-10">
    <div className="max-w-3xl mx-auto">
      <Link to="/" className="inline-flex items-center gap-1.5 text-[12px] text-cyan-400 hover:text-cyan-200 mb-6">
        <ArrowLeft className="w-3.5 h-3.5" /> Back to map
      </Link>
      <h1 className="text-3xl font-semibold text-cyan-50 mb-4">About OutbreakMap</h1>
      <p className="text-cyan-400 text-[14px] mb-8">An independent radar for global outbreak signals.</p>
    </div>
  </div>
);
export default AboutPage;
